var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFaceNeutral = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 17"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#face-neutral_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M5.392 10.985h5.333m-.667-4h.007m-4.007 0h.007m8.66 2a6.667 6.667 0 1 1-13.333 0 6.667 6.667 0 0 1 13.333 0m-4.333-2a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0m-4 0a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "face-neutral_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.059.984h16v16h-16z"
})))));
export { SvgFaceNeutral as ReactComponent };
export default __webpack_public_path__ + "assets/images/face-neutral.92bbbc543e5b7a7b7735648ac91b740f.svg";